import Vue from 'vue'
import moment from 'moment'

Vue.filter('localeAmount', (number) => {
    if (number) {
        return Math.round(number).toLocaleString('en-IN', { useGrouping: true })
    }
    return number
})

Vue.filter('localeAmountNormal', (number) => {
    if (number) {
        return (number).toLocaleString('en-IN', { useGrouping: true })
    }
    return number
})

Vue.filter('localeAmountPaisa', (number) => {
    if (!isNaN(number) && number !== null) {
        return Math.round((number / 100)).toLocaleString('en-IN', { useGrouping: true })
    } else {
        return '--'
    }
})

Vue.filter('localeAmountPaisaToRupee', (number) => {
    if (!isNaN(number) && number !== null) {
        return parseFloat((number / 100).toFixed(2)).toLocaleString('en-IN', { useGrouping: true })
    } else {
        return '--'
    }
})

Vue.filter('formatDate', (date) => {
    const tempDate = new Date(date)
    const isDate = (tempDate !== 'Invalid Date') && !isNaN(tempDate)
    if (isDate) {
        return tempDate.toLocaleDateString('en-IN')
    }
    return ''
})

Vue.filter('customFormatDate', (date) => {
    if (date) {
        return moment(String(date)).format('DD MMM YYYY, hh:mm A')
    }
    return ''
})

Vue.filter('earningsFormatDate', (date) => {
    if (date) {
        return moment(String(date)).format('MMM YYYY')
    }
    return ''
})

Vue.filter('capitalize', (value) => {
    return value[0].toUpperCase() + value.slice(1)
})
